import { ClientDataService, IClientDataDoc } from '../../../services/clientData.service'

export class IntubationService extends ClientDataService {
  private DISTANCE_UNIT_DOC = 'tb_intubation_dist_secured'
  private METHOD_DOC = 'tb_prprocedure_action'
  private SECURED_VIA_DOC = 'tb_prtube_secured_via'
  private VERIFIED_BY_DOC = 'tb_nemsis3_airway_personnel'
  private VERIFICATION_VIA_DOC = 'tb_pret_verify_v3'
  private MALLAPATI_DOC = 'tb_prmallampati'
  private LARYNGOSCOPIC_GRADE_DOC = 'tb_prlaryngoscope_grade'
  private STYLET_USED_DOC = 'tb_prstylet_used' // no data
  private CUFF_FILL_DOC = 'tb_prcuff_fill' // no data
  private LARYNGOSCOPE_BLADE_DOC = 'tb_prlaryngoscope_blade'
  private INDICATIONS_DOC = 'tb_nemsis3_airway_indicator'
  private AIRWAY_COMPLICATIONS_DOC = 'tb_nemsis3_airway_comp'
  private RSI_PROTOCOL_OPTIONS = 'tb_rsiprotocol-custom'
  private SELLICK_MANEUVER_OPTIONS = 'tb_sellick-maneuver-custom'
  private AIRWAY_TEMPERATURE_OPTIONS = 'tb_airway-temperature-custom'

  async getDistanceUnitOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.DISTANCE_UNIT_DOC)
  }

  async getMethodOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.METHOD_DOC)
  }

  async getSecuredViaOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.SECURED_VIA_DOC)
  }

  async getVerifiedByOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.VERIFIED_BY_DOC)
  }

  async getVerificationViaOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.VERIFICATION_VIA_DOC)
  }

  async getRSIProtocolOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.RSI_PROTOCOL_OPTIONS)
  }

  async getSellickManeuverOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.SELLICK_MANEUVER_OPTIONS)
  }

  async getMallampatiOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.MALLAPATI_DOC)
  }

  async getLaryngoscopicGradeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.LARYNGOSCOPIC_GRADE_DOC)
  }

  async getStyletUsedOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.STYLET_USED_DOC)
  }

  async getCuffFillOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.CUFF_FILL_DOC)
  }

  async getLaryngoscopeBladeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.LARYNGOSCOPE_BLADE_DOC)
  }

  async getIndicationsOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.INDICATIONS_DOC)
  }

  async getAirwayComplicationsOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.AIRWAY_COMPLICATIONS_DOC)
  }

  async getAirTemperatureUnitOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.AIRWAY_TEMPERATURE_OPTIONS)
  }
}
